import Characters from '../components/characters';
import Game from '../components/game';
import Ranking from '../components/ranking';
import Social from '../components/social';
import Trailer from '../components/trailer';
// import SoundTrack from '../components/soundTrack';
import Screenshots from '../components/screenshots';

const TYPES = {
  game: Game,
  characters: Characters,
  ranking: Ranking,
  social: Social,
  trailer: Trailer,
  // soundtrack: SoundTrack,
  screenshots: Screenshots,
};

/**
 * Get the content component based on type and state
 *
 * @param {{type: string, locked: boolean}} content
 * @returns {class}
 */
export default function getContentComponent(content) {
  let Content = TYPES[content.type];
  return Content;
}
